"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENUM = void 0;
var ENUM = /** @class */ (function () {
    function ENUM(values, index) {
        this.values = values;
        this.index = index;
    }
    Object.defineProperty(ENUM.prototype, "value", {
        get: function () {
            var _this = this;
            var result = this.values.filter(function (item) {
                return item.key === _this.index;
            });
            return result && result[0];
        },
        enumerable: false,
        configurable: true
    });
    return ENUM;
}());
exports.ENUM = ENUM;
//# sourceMappingURL=enum.js.map